import { preprocessData } from 'redux/store';

export const UPDATE_ALL_FORM_DATA = 'formData/UPDATE_ALL_FORM_DATA';

export const updateAllFormData = formData => ({
    type: UPDATE_ALL_FORM_DATA,
    payload: preprocessData(formData)
});

// Thunk action for updating all form data
export const refreshFormData = formData => dispatch => {
    dispatch(updateAllFormData(formData));
};
